import styled from 'styled-components';
import { LoginSaveCarStyled } from '../LoginSaveCarStyled';
import { rem } from 'polished';

export const LoginSaveCarStyledAP = styled(LoginSaveCarStyled)``;
